import * as R from 'ramda'

import intf from './interface.js'
import schema from './schema.js'

const implementBy = impl => {
  const reqData = intf(impl)

  Object.keys(reqData).forEach(key => {
    if (!R.has(key, impl)) {
      throw new Error(`reqData implement needs ${key} function`)
    }
  })

  return reqData
}

export default {
  implementBy,
  interface: () => intf(),
  schema,
}
